// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block__c7c {
  position: relative;
  padding: calc(var(--ring-unit) * 3) 0;

  border-top: 1px solid var(--ring-line-color);

  .blockHeader__d59 + .blockContent__fc2 {
    margin-top: calc(var(--ring-unit) * 2);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugin-rules-bundle-dialog/plugin-rules-bundle-dialog.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qCAAqC;;EAErC,4CAA4C;;EAE5C;IACE,sCAAsC;EACxC;AACF","sourcesContent":[".block {\n  position: relative;\n  padding: calc(var(--ring-unit) * 3) 0;\n\n  border-top: 1px solid var(--ring-line-color);\n\n  .blockHeader + .blockContent {\n    margin-top: calc(var(--ring-unit) * 2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"block": `block__c7c`,
	"blockHeader": `blockHeader__d59`,
	"blockContent": `blockContent__fc2`
};
export default ___CSS_LOADER_EXPORT___;
